import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaExclamationTriangle, FaTimes, FaTrash } from "react-icons/fa";
import myToast from "../Utils/MyToast";
import SessionManager from "../Utils/SessionManager";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-delete-paper-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 480px;
  }
  .mdl-delete-paper-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-delete-paper-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(239, 154, 154, 0.55);
    box-shadow: 0 12px 28px rgba(229, 57, 53, 0.12);
    background: #fff;
  }
  .mdl-delete-paper-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #ef5350 0%, #e53935 55%, #c62828 100%);
  }
  .mdl-delete-paper-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-delete-paper-dialog .modal-body {
    padding: 16px 14px 12px;
    background: linear-gradient(180deg, #fff8f8 0%, #ffffff 42%);
  }
  .mdl-delete-paper-dialog .modal-footer {
    border-top: 1px solid #ffebee;
    padding: 10px 14px;
    background: #fff5f5;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mdp-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mdp-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mdp-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mdp-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .mdp-body {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 12px;
    border-radius: 10px;
    border: 2px solid rgba(239, 154, 154, 0.55);
    background: #fff;
  }
  .mdp-body__icon {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ffebee;
    color: #e53935;
    font-size: 16px;
  }
  .mdp-body__text {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: #455a64;
    line-height: 1.45;
  }
  .mdp-body__text strong {
    color: #c62828;
    font-weight: 800;
  }
  .mdp-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mdp-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .mdp-btn--ghost {
    background: #fff;
    border-color: #ef9a9a;
    color: #c62828;
  }
  .mdp-btn--ghost:hover:not(:disabled) { background: #ffebee; }
  .mdp-btn--danger {
    background: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
    border-color: #e53935;
    color: #fff;
  }
`;

const MdlDeletePaper = ({
  actionClose,
  paper,
  exam_id,
  exam_name,
  actionDelete,
}) => {
  const [loading, setLoading] = useState(false);
  const [paperName, setPaperName] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [examPaperId, setExamPaperId] = useState("");

  useEffect(() => {
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-delete-paper", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, []);

  useEffect(() => {
    if (!paper) return;
    setSessionId(paper.session_id || "");
    setExamPaperId(paper.exam_paper_id || "");
    setPaperName(paper.exam_paper_name || paper.name || "");
  }, [paper]);

  //Created By Cursor
  const handleClose = useCallback(() => {
    if (loading) return;
    actionClose();
  }, [actionClose, loading]);

  //Created By Cursor
  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      const response = await axios.get(`${API_BASE()}deleteExamPaper.php`, {
        params: {
          school_code: schoolCode,
          staff_id: staffId,
          session_id: sessionId,
          exam_id,
          exam_paper_id: examPaperId,
          exam_paper_name: paperName,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Paper deleted successfully!");
        if (typeof actionDelete === "function") actionDelete();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Failed to delete paper. Please try again."
        );
      }
    } catch (error) {
      console.error("Delete paper error:", error);
      myToast.notify_error("An error occurred while deleting the paper.");
    } finally {
      setLoading(false);
    }
  }, [actionDelete, examPaperId, exam_id, paperName, sessionId]);

  return (
    <Modal
      show
      onHide={handleClose}
      animation={false}
      centered
      dialogClassName="mdl-delete-paper-dialog"
      aria-labelledby="mdl-delete-paper-title"
    >
      <Modal.Header closeButton={!loading}>
        <div className="mdp-title" id="mdl-delete-paper-title">
          <span className="mdp-title__icon" aria-hidden>
            <FaTrash />
          </span>
          <div>
            <div className="mdp-title__main">Delete Paper</div>
            <div className="mdp-title__sub">
              {exam_name || "Exam"} · This cannot be undone
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="mdp-body">
          <span className="mdp-body__icon" aria-hidden>
            <FaExclamationTriangle />
          </span>
          <p className="mdp-body__text">
            Are you sure you want to delete{" "}
            <strong>{paperName || "this paper"}</strong>?
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="mdp-btn mdp-btn--ghost"
          onClick={handleClose}
          disabled={loading}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mdp-btn mdp-btn--danger"
          onClick={handleDelete}
          disabled={loading}
        >
          <FaTrash aria-hidden />
          {loading ? "Deleting…" : "Delete"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlDeletePaper;
